import subscriptionAmendTemplate from '../../views/customer-center/subscription-amend.html';
import subscriptionBuyTemplate from '../../views/customer-center/subscription-buy.html';
import subscriptionOrderTemplate from '../../views/customer-center/subscription-order.html';
import viewUsageTemplate from '../../views/customer-center/view-usage.html';
import cancelSubscriptionTemplate from '../../views/customer-center/cancel-subscription.html';
import cancelEnterpriseSubscriptionTemplate from '../../views/customer-center/cancel-enterprise-subscription.html';
import enterpriseCancelMessageTemplate from '../../views/customer-center/enterprise-cancel-message.html';
import reactivateSubscriptionTemplate from '../../views/customer-center/reactivate-subscription.html';

export default function (app) {
  app
    .config([
      '$stateProvider',
      '$urlRouterProvider',
      function ($stateProvider, $urlRouterProvider) {
        $urlRouterProvider.otherwise('login');

        const loginState = {
          name: 'login',
          url: '/login',
          template: '<div react-component path="login"></div>',
          authBlock: true,
        };

        const subscriptionState = {
          name: 'subscription',
          url: '/subscription',
          auth: true,
          templateUrl: '/account/subscription',
        };

        const amendSubscriptionState = {
          name: 'subscription.amend',
          auth: true,
          params: { ratePlanCtrl: {} },
          views: {
            popup: {
              template: subscriptionAmendTemplate,
            },
          },
        };

        const buySubscriptionState = {
          name: 'subscription.buy',
          auth: true,
          params: { params: null },
          views: {
            popup: {
              template: subscriptionBuyTemplate,
            },
          },
        };

        const orderSubscriptionState = {
          name: 'subscription.order',
          auth: true,
          params: { params: null },
          views: {
            popup: {
              template: subscriptionOrderTemplate,
            },
          },
        };

        const usageSubscriptionState = {
          name: 'subscription.usage',
          auth: true,
          views: {
            popup: {
              template: viewUsageTemplate,
            },
          },
        };

        const cancelSubscriptionState = {
          name: 'subscription.cancel',
          auth: true,
          params: { subscriptionId: {}, subscription: {}, ratePlan: {} },
          views: {
            popup: {
              template: cancelSubscriptionTemplate,
            },
          },
        };

        const cancelEnterpriseSubscriptionState = {
          name: 'subscription.cancelEnterprise',
          auth: true,
          params: {
            enterpriseData: {},
          },
          views: {
            popup: {
              template: cancelEnterpriseSubscriptionTemplate,
            },
          },
        };

        const churnSubscriptionState = {
          name: 'subscription.churn-survey',
          auth: true,
          params: { subscription: {}, ratePlan: {}, onComplete: () => undefined },
          views: {
            popup: {
              templateProvider: [
                'klConfigService',
                '$state',
                function (ConfigService) {
                  return ConfigService.getConfig().then(() => {
                    return '<div react-component path="survey"></div>';
                  });
                },
              ],
            },
          },
        };

        const cancelledEnterpriseSubscriptionState = {
          name: 'subscription.enterprise-cancelled',
          auth: true,
          views: {
            popup: {
              template: enterpriseCancelMessageTemplate,
            },
          },
        };

        const reactivateSubscriptionState = {
          name: 'subscription.uncancel',
          auth: true,
          params: { subscriptionNumber: {} },
          views: {
            popup: {
              template: reactivateSubscriptionTemplate,
            },
          },
        };

        const previewSubscriptionState = {
          name: 'amendSubscription.preview',
          auth: true,
          views: {
            popup: {
              template:
                '<button ng-click="ctrl.confirmChanges()">Confirm changes</button><button ng-click="ctrl.closePopup()">Cancel</button>',
            },
          },
        };

        const uploadManagementState = {
          name: 'upload',
          url: '/upload',
          template: '<div react-component path="uploadManagement"></div>',
          auth: true,
        };

        const uploadManagementSubFolderState = {
          name: 'upload-child',
          url: '/upload/:guid',
          template: '<div react-component path="uploadManagement"></div>',
          params: {
            guid: { type: 'string' },
          },
          auth: true,
        };

        const uploadManagementSharedContentState = {
          name: 'upload-share-content',
          url: '/upload/share/content/:shareGuid/:contentGuid',
          template: '<div react-component path="uploadManagementSharedContent"></div>',
          params: {
            shareGuid: { type: 'string' },
            contentGuid: { type: 'string' },
          },
        };

        const panoramaGalleryEditorState = {
          name: 'gallery-editor',
          url: '/panoramaGallery/editor/:galleryId',
          template: '<div react-component path="galleryEditor"></div>',
          params: {
            galleryId: { type: 'string' },
          },
          auth: true,
        };

        const panoramaGalleryReaderState = {
          name: 'gallery-reader',
          url: '/panoramaGallery/reader/:galleryId',
          template: '<div react-component path="galleryReader"></div>',
          params: {
            galleryId: { type: 'string' },
          },
          auth: true,
        };

        const panoramaGallerySharedState = {
          name: 'gallery-shared',
          url: '/panoramaGallery/view/:shareGuid/:contentGuid',
          template: '<div react-component path="galleryShared"></div>',
          params: {
            shareGuid: { type: 'string' },
            contentGuid: { type: 'string' },
          },
        };

        const managedStopDeleteState = {
          name: 'managed-user-stop-delete',
          url: '/managed-user-stop-delete',
          templateUrl: '/account/managed-user-stop-delete',
          auth: false,
        };

        $stateProvider
          .state(loginState)
          .state(subscriptionState)
          .state(uploadManagementSubFolderState)
          .state(uploadManagementState)
          .state(amendSubscriptionState)
          .state(buySubscriptionState)
          .state(orderSubscriptionState)
          .state(usageSubscriptionState)
          .state(cancelSubscriptionState)
          .state(cancelEnterpriseSubscriptionState)
          .state(cancelledEnterpriseSubscriptionState)
          .state(reactivateSubscriptionState)
          .state(previewSubscriptionState)
          .state(managedStopDeleteState)
          .state(churnSubscriptionState)
          .state(uploadManagementSharedContentState)
          .state(panoramaGalleryEditorState)
          .state(panoramaGallerySharedState)
          .state(panoramaGalleryReaderState);
      },
    ])
    .run();
}
